import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { Divider, Typography, Stack, MenuItem, Button, Skeleton, Box, CircularProgress } from '@mui/material';
import MenuPopover from '../../../components/MenuPopover';
// import { PATH_DASHBOARD } from '../../../routes/paths';
import { useAccountPopover } from './hooks/useAccountPopover';
import Icon from '../../../components/Icon';
import Scrollbar from '../../../components/Scrollbar';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  // const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    handleOpen,
    handleLogout,
    handleSelectDevice,
    open,
    error,
    devices,
    selectedDevice,
    devicesSkeleton,
    deviceLoading,
    mainDeviceLoading,
    handleClose,
  } = useAccountPopover();
  const renderDeviceStatus = (device) => {
    if (device.isPrimary && device.Name !== selectedDevice.Name) {
      return (
        <Box sx={{ mr: '-3px !important' }}>
          <Icon name={'refresh'} color="#627284" width={12} height={12} />
        </Box>
      );
    }
    if (device.IsActive) {
      return <Box sx={{ width: '10px', height: '10px', borderRadius: '100%', bgcolor: '#08660D' }} />;
    }
    return <Box sx={{ width: '10px', height: '10px', borderRadius: '100%', bgcolor: '#c4cbd4' }} />;
  };

  return (
    <>
      <Button sx={{ width: 46, height: 46, borderRadius: '50%', minWidth: 36 }} onClick={handleOpen}>
        <Typography variant="body1" color="#95A2B0">
          {selectedDevice &&
            selectedDevice.Name
              .split(' ')
              .map((part) => part.charAt(0))
              .join('')}
        </Typography>
      </Button>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Stack sx={{ p: 1 }}>
          {devicesSkeleton && <Skeleton animation="wave" />}
          {!devicesSkeleton && devices.length === 0 && (
            <Typography variant="body2" sx={{ mx: 'auto', color: '#95A2B0' }}>
              {t('There is no device')}
            </Typography>
          )}
          <Scrollbar sx={{ maxHeight: 370 }}>
          {!devicesSkeleton &&
            devices.length > 0 &&
            devices.map((device, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  handleSelectDevice(device);
                }}
                sx={{
                  ...(device.Name === selectedDevice.Name && {
                    bgcolor: '#F5F4FF',
                    border: '1px solid #6152F1',
                  }),
                  ...(
                    !device.IsActive && {
                      cursor: 'default',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                    }
                  ),
                  px: '10px',
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                >
                  {(deviceLoading && device.Name === selectedDevice.Name) ||
                  (mainDeviceLoading && device.Name === selectedDevice.Name) ? (
                    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CircularProgress size="20px" />
                    </Box>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#95A2B0',
                        ...(device.isPrimary && {
                          fontWeight: '700',
                          color: '#627284',
                        }),
                        ...(!device.IsActive && {
                          color: '#c4cbd4',
                          }
                        ),
                      }}
                    >
                      {device.Name}
                    </Typography>
                  )}
                  {renderDeviceStatus(device)}
                </Stack>
              </MenuItem>
            ))}
          </Scrollbar>
          {error && (
            <Typography variant="body2" sx={{ mx: 'auto', color: '#B72136' }}>
              {error}
            </Typography>
          )}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {t('Logout')}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
